/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tap_To_OpenInputs */

const en_tap_to_open = /** @type {(inputs: Tap_To_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap to open!`)
};

const ar_tap_to_open = /** @type {(inputs: Tap_To_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اضغط للفتح!`)
};

const de_tap_to_open = /** @type {(inputs: Tap_To_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Öffnen tippen!`)
};

const es_tap_to_open = /** @type {(inputs: Tap_To_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Toca para abrir!`)
};

const fr_tap_to_open = /** @type {(inputs: Tap_To_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appuyez pour ouvrir !`)
};

const it_tap_to_open = /** @type {(inputs: Tap_To_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tocca per aprire!`)
};

const ja_tap_to_open = /** @type {(inputs: Tap_To_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タップして開く！`)
};

const ko_tap_to_open = /** @type {(inputs: Tap_To_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`탭하여 열기!`)
};

const pt_br_tap_to_open = /** @type {(inputs: Tap_To_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toque para abrir!`)
};

const ru_tap_to_open = /** @type {(inputs: Tap_To_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нажмите, чтобы открыть!`)
};

const th_tap_to_open = /** @type {(inputs: Tap_To_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แตะเพื่อเปิด!`)
};

const tr_tap_to_open = /** @type {(inputs: Tap_To_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Açmak için dokun!`)
};

const zh_cn_tap_to_open = /** @type {(inputs: Tap_To_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点击打开蛋糕盒！`)
};

const zh_tw_tap_to_open = /** @type {(inputs: Tap_To_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`點擊打開蛋糕盒!`)
};

/**
* | output |
* | --- |
* | "Tap to open!" |
*
* @param {Tap_To_OpenInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tap_to_open = /** @type {((inputs?: Tap_To_OpenInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tap_To_OpenInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tap_to_open(inputs)
	if (locale === "ar") return ar_tap_to_open(inputs)
	if (locale === "de") return de_tap_to_open(inputs)
	if (locale === "es") return es_tap_to_open(inputs)
	if (locale === "fr") return fr_tap_to_open(inputs)
	if (locale === "it") return it_tap_to_open(inputs)
	if (locale === "ja") return ja_tap_to_open(inputs)
	if (locale === "ko") return ko_tap_to_open(inputs)
	if (locale === "pt_br") return pt_br_tap_to_open(inputs)
	if (locale === "ru") return ru_tap_to_open(inputs)
	if (locale === "th") return th_tap_to_open(inputs)
	if (locale === "tr") return tr_tap_to_open(inputs)
	if (locale === "zh_cn") return zh_cn_tap_to_open(inputs)
	return zh_tw_tap_to_open(inputs)
});